import clipboardCopy from 'clipboard-copy';

export const copyReference = (path: string) => (event: React.MouseEvent) => {
  event.stopPropagation();
  clipboardCopy(`{{${path}}}`).catch();
};
